// extracted by mini-css-extract-plugin
module.exports = {"main":"Projects_main__3DPH2","projImg":"Projects_projImg__haHiQ","item":"Projects_item__ZQdHv","center":"Projects_center__2nlpZ"};